<template>
	<div class="wrapper notify">
		<div class="content">
			<div class="topbar">
				<div class="logo">
					<router-link to="/profile"><img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo"
							class="logo" /></router-link>
				</div>
				<div class="info">
					<div class="notifications">
						<div class="icon">
							<!-- <div class="counter"></div> -->
						</div>
					</div>
					<div class="profile">
						<img :src="avatarImage" :alt="avatarName" class="currentAvatar" />
					</div>
				</div>
			</div>
			<h2>{{ t('txt_notifications') }}</h2>
			<div v-if="subscriptionStatus" class="ask">
				<p>{{ t('txt_subscribe_for_updates') }}</p>
				<button @click="triggerSubscribe" class="green">{{ t('txt_subscribe') }}</button>
			</div>
			<div v-if="loading" class="skeleton-container">
				<div class="skeleton-message" v-for="n in 6" :key="n">
					<div class="skeleton-padding">
						<div class="skeleton-title animate__animated animate__pulse animate__infinite"></div>
						<div class="skeleton-content animate__animated animate__pulse animate__infinite"></div>
					</div>
				</div>
			</div>
			<div v-else class="notifications-list">
				<div v-for="message in notifications" :key="message.id" class="message"
					:class="{ read: message.readed }">
					<div class="padding">
						<h2>{{ message.title }}</h2>
						<p>{{ message.content }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
	<MobileNav :selected="selectedId" />
</template>

<script>
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
import apiClient from '@/utils/axios';

const publicVapidKey = 'BAF23CL0JV0eyT_EJ7WLdLObH7J-khN8-8yxfZi7ZgpCfAUUbYIlzTIp66GmF1L_V0ZCSiefpMYJXGmpMNVrjbY';

export default {
	props: ['id'],
	name: 'NotificationsPage',
	data() {
		return {
			loading: true,
			selectedId: 3,
			notifications: [],
			selectedAvatar: localStorage.getItem('avatar'),
			subscriptionStatus: false,
			avatars: [
				{ id: '1', image: require('../assets/img/eda-spomenik.svg'), name: 'fox' },
				{ id: '2', image: require('../assets/img/goriska-vrtnica.svg'), name: 'goriska-vrtnica' },
				{ id: '3', image: require('../assets/img/goriski-grad.svg'), name: 'goriski-grad' },
				{ id: '4', image: require('../assets/img/soca.svg'), name: 'soca' },
				{ id: '5', image: require('../assets/img/solkanski-most.svg'), name: 'solkanski-most' },
				{ id: '6', image: require('../assets/img/solkanski-radic.svg'), name: 'solkanski-radic' },
				{ id: '7', image: require('../assets/img/soska-postrv.svg'), name: 'postrv' },
				
			]
		};
	},
	computed: {
		fullName() {
			return `${keycloak.tokenParsed?.given_name || 'Name'} ${keycloak.tokenParsed?.family_name || 'Surname'}`;
		},
		avatarImage() {
			return this.getAvatarById(this.selectedAvatar)?.image || this.getAvatarById('1')?.image;
		},
		avatarName() {
			return this.getAvatarById(this.selectedAvatar)?.name || this.getAvatarById('1')?.name;
		}
	},
	methods: {
		getAvatarById(id) {
			return this.avatars.find(avatar => avatar.id === id);
		},
		urlBase64ToUint8Array(base64String) {
			const padding = '='.repeat((4 - base64String.length % 4) % 4);
			const base64 = (base64String + padding)
				.replace(/-/g, '+')
				.replace(/_/g, '/');
			const rawData = window.atob(base64);
			const outputArray = new Uint8Array(rawData.length);
			for (let i = 0; i < rawData.length; ++i) {
				outputArray[i] = rawData.charCodeAt(i);
			}
			return outputArray;
		},
		async subscribeUser() {
			console.log('subscribeUser called');
			try {
				const registration = await navigator.serviceWorker.ready;
				console.log('Service worker is ready:', registration);

				const subscription = await registration.pushManager.subscribe({
					userVisibleOnly: true,
					applicationServerKey: this.urlBase64ToUint8Array(publicVapidKey)
				});

				const subscribeData = {
					keycloak_id: keycloak.tokenParsed.sub,
					subscription: subscription
				};
				const response = await apiClient.post('/' + localStorage.getItem('lang') + '/api/subscribe', subscribeData);
				if(response.data.success == true){
					registration.showNotification(this.t('txt_subscription_successful'), {
						body: this.t('txt_subscription_successful_message'), //'You have successfully subscribed to push notifications.',
						icon: '/img/favicon/web-app-manifest-192x192.png',
						badge: '/img/favicon/web-app-manifest-192x192.png'
					});
					this.subscriptionStatus = false;
				}
			} catch (error) {
				console.error('Error during subscription:', error);
				this.subscriptionStatus = false;
			}
		},
		askPermission() {
			return new Promise((resolve, reject) => {
				const permissionResult = Notification.requestPermission(result => {
					resolve(result);
				});

				if (permissionResult) {
					permissionResult.then(resolve, reject);
				}
			}).then(permissionResult => {
				if (permissionResult === 'granted') {
					return this.subscribeUser();
				} else {
					this.subscriptionStatus = false;
					throw new Error('Permission not granted for Notification');
				}
			}).catch(error => {
				console.error('Error in askPermission:', error);
			});
		},
		triggerSubscribe() {
			if ('serviceWorker' in navigator && 'PushManager' in window) {
				if ('Notification' in window) {
					if (Notification.permission === 'granted') {
						this.subscribeUser();
						this.subscriptionStatus = true;
					} else if (Notification.permission === 'denied') {
						this.subscriptionStatus = false;
					} else {
						this.askPermission();
					}
				} else {
					this.subscriptionStatus = false;
				}
			} else {
				console.error('Service Worker or Push Manager not supported');
			}
		},
		detectiOSChrome() {
			const userAgent = navigator.userAgent;
			return /CriOS/i.test(userAgent) && /iPhone|iPad|iPod/i.test(userAgent);
		}
	},
	setup() {
		const { t } = useI18n();
		return {
			t
		};
	},
	mounted() {
		this.isAuthenticated = keycloak.authenticated;
		if (this.isAuthenticated) {
			this.loading = true;

			apiClient.get('/' + localStorage.getItem('lang') + '/api/user/notifications')
				.then(response => {
					this.notifications = response.data;
					this.loading = false;
				})
				.catch(apiError => {
					console.error('Failed to send user data:', apiError);
					this.loading = false;
				});

			if ('serviceWorker' in navigator && 'PushManager' in window) {
				if ('Notification' in window && !this.detectiOSChrome()) {
					console.log('here',Notification.permission);
					if (Notification.permission === 'granted') {
						this.subscriptionStatus = false;
					} else {
						this.subscriptionStatus = true;
					}
				} else {
					this.subscriptionStatus = false;
					console.log('here',Notification.permission);
				}
			}
		} else {
			this.$router.push('/login');
		}
	},
	watch() {
		this.subscriptionStatus;
	}
};
</script>

<style lang="sass" scoped>

</style>